export default (value) => {
  if (!value && value !== 0) return value;
  return `${value.toFixed(2).replace('.', ',')}`;
};
